// Cálculo del cotizador en el navegador: espejo de logica/descuentos.ts del
// worker, para mostrar totales y el nivel que firma sin esperar al servidor.
import type { Nivel, Umbral } from "../tipos";

export interface Linea {
  clave: string;
  productoId: string | null;
  producto: string | null;
  descripcion: string;
  cantidad: number;
  precioLista: number;
  descuentoPct: number;
}

export const r2 = (n: number) => Math.round((n + Number.EPSILON) * 100) / 100;

/** Mismo cálculo que el servidor (logica/descuentos.ts), para mostrar totales sin esperar. */
export function totalesDe(lineas: Linea[], global: number) {
  const calc = lineas.map((l) => {
    const aplicado = r2(l.precioLista * (1 - l.descuentoPct / 100));
    return { ...l, precioAplicado: aplicado, importe: r2(aplicado * l.cantidad) };
  });
  const subtotal = r2(calc.reduce((s, p) => s + p.precioLista * p.cantidad, 0));
  const tras = r2(calc.reduce((s, p) => s + p.importe, 0));
  const total = r2(tras * (1 - Math.min(100, Math.max(0, global)) / 100));
  const descuentoMonto = r2(subtotal - total);
  const descuentoPct = subtotal > 0 ? r2((descuentoMonto / subtotal) * 100) : 0;
  const iva = r2(total * 0.16);
  return { partidas: calc, subtotal, total, descuentoMonto, descuentoPct, iva, conIva: r2(total + iva) };
}

export function nivelPara(pct: number, umbrales: Umbral[]): Nivel {
  if (pct <= 0) return "ejecutivo";
  if (!umbrales.length) return "subgerente";
  const orden: Nivel[] = ["ejecutivo", "subgerente", "subdirector", "director"];
  for (const u of [...umbrales].sort((a, b) => Number(a.pctMin) - Number(b.pctMin))) {
    const max = u.pctMax === null ? Infinity : Number(u.pctMax);
    if (pct > Number(u.pctMin) && pct <= max) return u.nivel;
  }
  return [...umbrales].sort((a, b) => orden.indexOf(b.nivel) - orden.indexOf(a.nivel))[0]!.nivel;
}
